import axios from '@/api/config';

const agentUserInfo = {
  getAgentUserInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfo/` + data, {});
  },
  getAgentUserInfo(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfo`, {
      params: data
    });
  },
  getAgentUserInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfoList`, {
      params: data
    });
  },
  getAgentUserInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfoTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/pageList`, data);
  },
  teacherPageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/teacherPageList`, data);
  },
  getMatureStudentList(data) {
    return axios.post(`${process.env.BASE_URL}/classInfoStudent/register`, data);
  },
  addAgentUserInfo(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/addAgentUserInfo`, data);
  },
  addTeacher(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/addTeacher`, data);
  },
  updateTeacher(data) {
    return axios.put(`${process.env.BASE_URL}/agentUserInfo/updateTeacher`, data);
  },
  rechargeAgentUserInfoAmount(data) {
    return axios.put(`${process.env.BASE_URL}/agentUserInfo/rechargeAgentUserInfoAmount`, data);
  },
  updateAgentUserInfo(data) {
    return axios.put(`${process.env.BASE_URL}/agentUserInfo/updateAgentUserInfo`, data);
  },
  deleteAgentUserInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/agentUserInfo/deleteAgentUserInfo`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/exportExcel`, {
      params: data
    });
  },
  getAgentTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentTeacherList`, {
      params: data
    });
  },
  getAgentInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfoList`, {
      params: data
    });
  },
  getHeadTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getHeadTeacherList`, {
      params: data
    });
  },
  getTeacherListInfo(){
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfoList`, );
  },
  getAcademicTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAcademicTeacherList`, {
      params: data
    });
  },
  getTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getTeacherList`, {
      params: data
    });
  },
  getAgentAmountStatsDTO(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentAmountStatsDTO`, {
      params: data
    });
  },
  getAgentUserAmountStats(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserAmountStats`, {
      params: data
    });
  },
  enabledUser(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/enabledUser`, data);
  },
  agentAmountLogPageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentAmountLog/pageList`, data);
  },
  resetPassword(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/resetPassword`, data);
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/importData`, data);
  },
  getExamSettingTeacherList(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/getExamSettingTeacherList`, data);
  },
  getAgentInfoListByAccount(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentInfoListByAccount`, {
      params: data
    });
  },
  addAgentInfoListByAccount(data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/addAgentInfoByForm`, data);
  },
  copySchoolPage(data) {
    return axios.post(`${process.env.BASE_URL}/pageWidgetRelation/copyApp`, data);
  },
  updateUserBind(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/bindDataPermission`, data);
  },
  getUserBindData(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getPermissionData`, {
      params: data
    });
  },
}

export default agentUserInfo;



// WEBPACK FOOTER //
// ./src/api/agentUserInfo.js